import { useKodeListe } from "@/hooks/useQueries";
import { formatLessons } from "@/util/number";
import { useMemo } from "react";

import {
  buildInjunctionLessonTypeRows,
  sumInjunctionLessonTypeColumn,
  type InjunctionLessonTypeLinje,
} from "./injunctionLessonTypeUtils";

interface PaalaegLessonTypeSummaryCardProps {
  linjer?: InjunctionLessonTypeLinje[];
  transferredLinjer?: InjunctionLessonTypeLinje[];
}

export const PaalaegLessonTypeSummaryCard = ({
  linjer,
  transferredLinjer,
}: PaalaegLessonTypeSummaryCardProps) => {
  const { kodeliste: efteruddannelsestyper, getKodelisteIsLoading } =
    useKodeListe("Efteruddannelsestype");
  const rows = useMemo(
    () =>
      buildInjunctionLessonTypeRows(
        linjer,
        transferredLinjer,
        efteruddannelsestyper,
      ),
    [linjer, transferredLinjer, efteruddannelsestyper],
  );
  const totalReported = useMemo(
    () => sumInjunctionLessonTypeColumn(rows, "reported"),
    [rows],
  );
  const totalTransferred = useMemo(
    () => sumInjunctionLessonTypeColumn(rows, "transferred"),
    [rows],
  );
  return (
    <div className="c-card p-4">
      <h3 className="h5 mb-3">Lektionsoversigt</h3>
      {getKodelisteIsLoading ? (
        <p className="text-muted mb-0">Indlæser typer...</p>
      ) : !rows.length ? (
        <p className="text-muted mb-0">
          Ingen lektioner fordelt på typer for dette pålæg.
        </p>
      ) : (
        <div className="table-responsive">
          <table className="table table-sm mb-0">
            <thead>
              <tr>
                <th>Type</th>
                <th className="text-end">Indberettet</th>
                <th className="text-end">
                  Overført til efteruddannelsesperiode
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.typeNr}>
                  <td>{row.typeLabel}</td>
                  <td className="text-end">{formatLessons(row.reported)}</td>
                  <td className="text-end">{formatLessons(row.transferred)}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="fw-semibold table-secondary">
                <td>I alt</td>
                <td className="text-end">{formatLessons(totalReported)}</td>
                <td className="text-end">{formatLessons(totalTransferred)}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      )}
    </div>
  );
};
